import { Box, Select, Button, ThemeProvider } from '@mui/material'
import Header from '../../components/Header'
import React from "react"
import { useState, useEffect } from "react"
import { useTheme } from '@mui/material'
import { useParams } from 'react-router-dom'

import * as Constants from '../../constants'

const Device = () => {
  let theme = useTheme()

  const [error, setError] = useState({ error: false, message: '' })
  const [success, setSuccess] = useState({ success: false, message: '' })
  const [owners, setOwners] = useState([])
  const [selectedOwner, setSelectedOwner] = useState([])

  const ids = useParams().ids

  const handleSubmit = () => {
    if (selectedOwner === '' || selectedOwner === 0) {
      setError({ error: true, message: 'Selecione um proprietário' })
      setSuccess({ success: false, message: '' })
      return
    }

    fetch(Constants.HOST + '/setOwnerDevice', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
        device_ids: ids
          .split(',')
          .filter((id) => id !== '')
          .map((id) => parseInt(id)),
        owner_id: selectedOwner,
      }),
    })
      .then((response) => {
        if (response.status !== 400 && response.status !== 200) {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        } else {
          response.json().then((data) => {
            if (data.success !== true) {
              setError({ error: true, message: data.message})
              setSuccess({ success: false, message: '' })
            } else {
              setError({ error: false, message: '' })
              setSuccess(data)
            }
          })
        }
      })
      .catch((error) => {
        setError({ error: true, message: 'Erro de comunicação com o servidor' })
        setSuccess({ success: false, message: '' })
      })
  }

  useEffect(() => {
    // Fetch owners
    fetch(Constants.HOST + '/owners', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
      }),
    })
      .then((response) => {
        if (response.status !== 400 && response.status !== 200) {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        } else {
          response.json().then((data) => {
            data = data.data
            if (data.owners === undefined || data.owners.length === 0) {
              setError({
                error: true,
                message: 'Erro de comunicação com o servidor',
              })
              setSuccess({ success: false, message: '' })
            } else {
              setError({ error: false, message: '' })
              setSuccess({ success: false, message: '' })
              setOwners(data.owners)
            }
          })
        }
      })
      .catch(() => {
        setError({ error: true, message: 'Erro de comunicação com o servidor' })
        setSuccess({ success: false, message: '' })
      })
  }, [])

  return (
    <Box m="20px">
      <Header
        title="Atribuindo proprietário"
        subtitle={
          'Dispositivo(s): ' +
          (ids.split(',').length === 1 ? ids.split(',')[0] : ids)
        }
      />
      {error.error && (
        <div style={{ color: 'red', margin: '10px 0' }}>{error.message}</div>
      )}
      {success.success && (
        <div style={{ color: 'green', margin: '10px 0' }}>
          {success.message}
        </div>
      )}

      <ThemeProvider theme={theme}>
        <Box sx={{ flexGrow: 1, display: 'flex' }}>
          <Select
            native
            onChange={(e) => {
              setSelectedOwner(e.target.value)
            }}
            sx={{ width: '100%', color: 'white' }}
          >
            <option value={0}>Selecione o novo proprietário</option>
            {owners.map((user) => (
              <option value={user.id} key={user.id} sx={{ color: 'white' }}>
                {user.name}
              </option>
            ))}
          </Select>
          <Button
            variant="outlined"
            sx={{
              marginLeft: '10px',
              bgcolor: 'green',
              marginTop: '10px',
              color: 'white',
            }}
            onClick={() => handleSubmit(selectedOwner)}
          >
            Executar
          </Button>
        </Box>
      </ThemeProvider>
    </Box>
  )
}

export default Device
